<template>
    <div class="answer row voffset2">
        <ul :class="[ isCriticStep ? 'list-unstyled' : 'list-inline text-center' ]">
            <li v-for="(answer, index) in currentStepAnswers" @click="selectAnswer(index)">
                 <i class="fa" :class="selectedAnswer == index ? 'fa-circle' : 'fa-circle-o'"></i>&nbsp;&nbsp;{{ answer }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        components: {
        },
        computed: {
            isAuditStep: function() {
                return this.$store.state.user.currentStep != "SATISFACTION_SURVEY";
            },
            isCriticStep: function() {
                return this.$store.state.user.currentStep == "CRITIC_STEP";
            },
            currentStepAnswers: function() {
                let answers = this.$store.getters.getCurrentStepAnswers;
                if (this.$store.state.user.currentStep == "CRITIC_STEP"
                    && this.currentCriteriaPercentageOfYes < 100)    {
                    return answers.slice(0,3);
                }
                return answers;
            },
            selectedAnswer: function()  {
                return this.$store.state.user.selectedAnswer;
            }
        },
        methods: {
            selectAnswer(answer)  {
                this.$store.dispatch('changeAnswer', answer);
            }
        },
        props: ['currentCriteriaPercentageOfYes', 'isFirstOrSecondStep']
    }
</script>
